var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rating)?_c('div',{staticClass:"most-rated"},[_c('svgicon',{attrs:{"icon":_vm.rating,"width":"1em","height":"1em","original":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }